import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  pagination: {
    background: '#fff',
    display: 'inline-block',
    marginTop: 10,
    marginBottom: 10,

    '& .MuiButtonBase-root': {
      width: 30,
      height: 30,
      border: '1px solid #022DB4',
      borderRadius: 0,
      margin: 0,
      color: '#022DB4',
      fontWeight: 'bold',
    },
    '& .Mui-selected': {
      background: '#022DB4',
      color: '#fff',
      fontWeight: 'bold',

      '&:hover': {
        background: '#022DB4',
        fontWeight: 'bold',
      },
    },
  },
});
